import DataLabelValueComponent from "../../../components/data-label-value/DataLabelValueComponent";
import {CommonService} from "../../../helpers";
import React from "react";

interface ContractCardComponentProps{
    jobDetails?:any;
}
const ContractCardComponent=(props:ContractCardComponentProps)=>{
    const {jobDetails}=props;
    return (
        <div className={'d-flex'}>
            <DataLabelValueComponent label={'Start Date'} className={'flex-equal'}>
                {jobDetails?.contract_details?.start_date ? CommonService.formattedDate(jobDetails?.contract_details?.start_date) : 'ASAP'}
            </DataLabelValueComponent>
            <DataLabelValueComponent label={'Number of Weeks'} className={'flex-equal'}>
                {jobDetails?.contract_details?.no_of_weeks ? jobDetails?.contract_details?.no_of_weeks : ''}
            </DataLabelValueComponent>
            <DataLabelValueComponent label={'Working Days'} className={'flex-equal'}>
                {jobDetails?.contract_details?.shift_duration ? jobDetails?.contract_details?.days_per_week : ''}
            </DataLabelValueComponent>
            <DataLabelValueComponent label={'Shift Duration'} className={'flex-equal'}>
                {jobDetails?.contract_details?.shift_duration ? jobDetails?.contract_details?.shift_duration + ' hrs' : ''}
            </DataLabelValueComponent>
            {/*<DataLabelValueComponent label={'Duration'} className={'flex-equal'}>*/}
            {/*    {jobDetails?.contract_details?.no_of_weeks ? jobDetails?.contract_details?.no_of_weeks + ' Weeks' : 'N/A'}*/}
            {/*</DataLabelValueComponent>*/}
            {/*<DataLabelValueComponent label={'Working Days'} className={'flex-equal'}>*/}
            {/*    {jobDetails?.contract_details?.days_per_week ? jobDetails?.contract_details?.days_per_week + ' Days' : 'N/A'}*/}
            {/*</DataLabelValueComponent>*/}
            <DataLabelValueComponent label={'Shift Time'} className={'flex-equal'}>
                {jobDetails?.contract_details?.shift_type ? CommonService.formatTitleCase(jobDetails?.contract_details?.shift_type) : ''}
            </DataLabelValueComponent>
        </div>
    )
}
export default ContractCardComponent
